// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohorts } from "../engagementApiSegmentCohorts/constants";
import type {
  SegmentCohortList,
  SegmentCohortsListParams,
} from "@dashboardApi/apis/engagementApiSegmentCohorts/types";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

/**
 * Note: default limit is high since legacy list does not paginate
 */
export const getSegmentCohorts = reactQueryTableFetcherAdapter(
  engagementApiSegmentCohorts,
  (
    signal: AbortSignal,
    { query, sortby, sortdir, limit = 999, start = 0, datatable_format }: SegmentCohortsListParams
  ): Promise<SegmentCohortList> => {
    return fetch(
      engagementApiSegmentCohorts,
      "GET",
      {
        query: serializeQueryObjects(query),
        limit,
        start,
        sortby,
        sortdir,
        datatable_format,
      },
      { signal }
    );
  }
);
